/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Task_Assigned_Fallback_TitleInputs */

const en_notifications_task_assigned_fallback_title = /** @type {(inputs: Notifications_Task_Assigned_Fallback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task assigned`)
};

const pt_br2_notifications_task_assigned_fallback_title = /** @type {(inputs: Notifications_Task_Assigned_Fallback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade atribuída`)
};

/**
* | output |
* | --- |
* | "Task assigned" |
*
* @param {Notifications_Task_Assigned_Fallback_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_assigned_fallback_title = /** @type {((inputs?: Notifications_Task_Assigned_Fallback_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Assigned_Fallback_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_assigned_fallback_title(inputs)
	return pt_br2_notifications_task_assigned_fallback_title(inputs)
});